module.exports = __webpack_public_path__ + "media/images/menu-3173a6314a4dce137620c7c99e4edf9d.png";